<template>
  <v-container id="hm-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-form ref="form" v-model="valid" lazy-validation>
      <h4>Team: {{ team }}</h4>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-text-field
            v-mask="'##/##/####'"
            maxlength="10"
            v-model="stat_data.event_date"
            label="Event Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-mask="'##:##'"
            placeholder="21:01"
            maxlength="5"
            v-model="stat_data.event_time"
            label="Event Time"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            attach
            v-model="stat_data.report_taken"
            :items="['Yes', 'No']"
            label="Report Taken"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            placeholder="##-#####"
            maxlength="8"
            v-model="stat_data.case_number"
            label="Case #"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-select
            attach
            multiple
            class=""
            label="Roster"
            v-model="stat_data.roster"
            id="rosters"
            :items="lst_clear_roster"
            item-text="name"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-text-field
            maxlength="180"
            v-model="stat_data.location"
            label="Location"
            counter="180"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-select
            attach
            multiple
            class=""
            label="Deployment Type"
            v-model="stat_data.deployment_type"
            id="Deployment"
            :items="[
              'Drug Testing/Identification',
              'HAZMAT call out response',
              'Other',
            ]"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-select
            attach
            v-model="stat_data.protein"
            :items="protein_items"
            label="Protein"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.radiation"
            label="Radiation"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.lel"
            label="LEL"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.voc"
            label="VOC"
            counter="60"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.co2"
            label="CO2"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.dosimeter"
            label="Dosimeter"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.narcan"
            label="Narcan"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            maxlength="60"
            v-model="stat_data.RIID"
            label="RIID"
            counter="60"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field
            maxlength="60"
            v-model="stat_data.back_pack"
            label="BackPack"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            maxlength="60"
            v-model="stat_data.trunarc"
            label="Trunarc"
            counter="60"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            maxlength="60"
            v-model="stat_data.MX908"
            label="MX908"
            counter="60"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-select
            attach
            multiple
            class=""
            label="PPE Used"
            v-model="stat_data.ppe"
            id="ppe"
            :items="[
              'Gloves',
              'Masks',
              'Tyvek Suit',
              'Level A',
              'APR Canister',
              'Other',
            ]"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-select
            attach
            multiple
            class=""
            label="Consumables Used"
            v-model="stat_data.consumables"
            id="Consumables"
            :items="[
              'Fentanyl NIK',
              'Meth NIK',
              'Cocaine NIK',
              'Heroin NIK',
              'Psilocybin NIK',
              'Scoopula',
              'MX 908 Strip',
              'PH Paper',
              'Plastic container',
              'Glass Container',
              'Other',
            ]"
          ></v-select>
        </v-col>
      </v-row>
      <!-- Equipment Used -->
      <v-row dense>
        <v-col cols="12" md="12">
          <v-select
            attach
            multiple
            class=""
            label="Equipment Used"
            v-model="stat_data.equipment_used"
            id="Equipment"
            :items="[
              'TruNarc',
              'First Defender',
              'Gemini',
              'Tru Defender',
              'MX 908',
              'FLIR',
              '5 Gas',
              'Air Monitoring',
              'Radiation Equipment',
              'Other',
            ]"
          ></v-select>
        </v-col>
      </v-row>
      <v-textarea
        outlined
        label="Equipment Broken and or Lost:"
        auto-grow
        v-model="stat_data.broken_lost"
        counter="8000"
      ></v-textarea>
      <v-textarea
        outlined
        label="Incident Details:"
        auto-grow
        v-model="stat_data.incident_details"
        counter="8000"
      ></v-textarea>
      <!-- <v-textarea
        outlined
        label="Other Information:"
        auto-grow
        v-model="stat_data.other_info"
        counter="8000"
      ></v-textarea> -->

      <!-- save/reset buttons -->
      <v-row class="">
        <v-col cols="12" class="d-flex justify-space-between">
          <v-btn
            color="cmpbk"
            class="mr-4 white--text"
            @click.prevent="save_stat"
          >
            Submit
          </v-btn>
          <v-btn
            v-if="edit_on == true"
            color="cmpbk"
            class="mr-4 white--text"
            @click="cancel_edit"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="edit_on == false"
            color="cmpbk"
            class="mr-4 white--text"
            @click="reset"
          >
            Reset Form
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "add_editclr",
  mixins: [bus_common],
  props: [
    "addedit_update_now",
    "incoming_edit",
    "source",
    "scrollpos",
    "edit_on",
    "lst_grants",
    "team",
    "readonly",
  ],
  watch: {
    addedit_update_now: function (val) {
      console.log("clear addedit_update_now");
      if (this.update_ready) {
        this.update_ready = true;
        this.swall_it("Entry Status", "Entry Saved", "success");
        this.stat_data = this.mno(this.stat_data_new);
        setTimeout(() => {
          this.stat_data.event_date = this.format_date_us(new Date());
          this.stat_data.event_time = this.getMilitaryTime();
        }, 500);

        console.log("Stat Date: " + this.stat_data.stat_date);
      }
    },
    incoming_edit: function (stat) {
      this.mrbreakpoint("incoming_editclr");
      this.stat_data = this.mno(stat);
      this.stat_data.event_date = this.format_date_us(
        this.stat_data.event_date
      );
    },
  },
  computed: {
    team_met() {
      if (this.edit_on) {
        if (this.stat_data.team == "MET1" || this.stat_data.team == "MET2") {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.team == "MET1" || this.team == "MET2") {
          return true;
        } else {
          return false;
        }
      }
    },
    dhours15() {
      let dhours15 = [];
      for (let hour = 0; hour <= 20; hour++) {
        for (let minutes = 0; minutes < 60; minutes += 15) {
          // let inc = `${hour.toString().padStart(2, "0")}:${minutes
          //   .toString()
          //   .padStart(2, "0")}`;
          let inc = (parseFloat(hour) + parseFloat(minutes / 100)).toFixed(2);
          dhours15.push(inc);
        }
      }
      return dhours15;
    },
    d10() {
      var d10 = [];
      for (let index = 0; index < 11; index++) {
        d10.push(index);
      }
      return d10;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
    d30() {
      var d30 = [];
      for (let index = 0; index < 31; index++) {
        d30.push(index);
      }
      return d30;
    },
    d60() {
      var d60 = [];
      for (let index = 0; index < 61; index++) {
        d60.push(index);
      }
      return d60;
    },
    grants() {
      var grants = [];
      grants.push("None");
      for (let index = 0; index < this.lst_grants.length; index++) {
        const element = this.lst_grants[index];
        grants.push(element.grant_name);
      }
      return grants;
    },
    tsep_fromId() {
      return this.$store.state.edit_tsep_fromId;
    },
  },
  data() {
    return {
      lst_clear_roster: [],
      valid: true,
      protein_items: [
        "-5",
        "-4",
        "-3",
        "-2",
        "-1",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
      ],
      stat_data: {
        rpd_stat_clrId: 0,
        case_number: "",
        team: "",
        event_date: "",
        event_time: "",
        roster: [],
        location: "",
        protein: "",
        deployment_type: [],
        report_taken: "",
        radiation: "",
        lel: "",
        voc: "",
        co2: "",
        dosimeter: "",
        narcan: "",
        RIID: "",
        back_pack: "",
        trunarc: "",
        MX908: "",
        ppe: [],
        consumables: [],
        broken_lost: "",
        equipment_used: [],
        other_info: "",
        incident_details: "",
      },
      stat_data_new: {
        rpd_stat_clrId: 0,
        case_number: "",
        team: "",
        event_date: "",
        event_time: "",
        roster: [],
        location: "",
        protein: "",
        deployment_type: [],
        report_taken: "",
        radiation: "",
        lel: "",
        voc: "",
        co2: "",
        dosimeter: "",
        narcan: "",
        RIID: "",
        back_pack: "",
        trunarc: "",
        MX908: "",
        ppe: [],
        consumables: [],
        broken_lost: "",
        equipment_used: [],
        other_info: "",
        incident_details: "",
      },
      stat_data_dev: {
        rpd_stat_clrId: 0,
        case_number: "99-12345",
        team: "CLEAR",
        event_date: "",
        event_time: "08:00",
        roster: ["member name 2"],
        location: "location",
        protein: "1",
        deployment_type: ["HAZMAT call out response"],
        report_taken: "Yes",
        radiation: "radiation",
        lel: "lel",
        voc: "voc",
        co2: "co2",
        dosimeter: "dosimeter",
        narcan: "narcan",
        RIID: "RIID",
        back_pack: "back_pack",
        trunarc: "trunarc",
        MX908: "MX908",
        ppe: ["Masks"],
        consumables: ["Cocaine NIK"],
        broken_lost: "tons of broken_lost",
        equipment_used: ["Tru Defender"],
        other_info: "other_info",
        incident_details: "incident_details",
      },
    };
  },
  methods: {
    get_clear_roster() {
      var self = this;

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_clear_roster";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_clear_roster = self.mno(data);

          this.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    save_stat() {
      this.mrbreakpoint("join");
      var total = 0;
      let stat_data = this.mno(this.stat_data);
      //   this.mrbreakpoint("save_stat 1");
      if (stat_data.protein == "") {
        stat_data.protein = 0;
      }
      stat_data.protein = parseInt(stat_data.protein);
      stat_data.team = this.team;

      stat_data.roster = stat_data.roster.join(",");
      stat_data.deployment_type = stat_data.deployment_type.join(",");
      stat_data.ppe = stat_data.ppe.join(",");
      stat_data.consumables = stat_data.consumables.join(",");
      stat_data.equipment_used = stat_data.equipment_used.join(",");

      stat_data.stat_date = this.format_date_sql(new Date(stat_data.stat_date));
      stat_data.event_date = this.format_date_sql(
        new Date(stat_data.event_date)
      );
      console.log(stat_data.stat_date);
      console.log("notes:" + stat_data.notes);

      this.update_ready = true;
      this.$emit("save_statclr", stat_data);
    },
    cancel_edit() {
      this.$emit("cancel_editclr", this.stat_data);
    },
    reset() {
      this.init();
      this.show_loader(false);
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      let self = this;
      this.get_clear_roster();
      console.log(this.show_addedit);
      setTimeout(() => {
        self.stat_data = self.mno(self.stat_data_new);
        this.stat_data.team = this.team;
        this.stat_data.event_date = this.format_date_us(new Date());
        this.stat_data.event_time = self.getMilitaryTime();
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
